import React from "react";

/**
 * Subtle dismissible banner summarizing new action items since the user's last visit.
 *
 * @example
 * <ActionItemsCatchUpBanner
 *   summary={{ new_count: 12, automatable_count: 5, open_count: 34 }}
 *   onDismiss={() => {}}
 *   onReviewAutomatable={() => {}}
 * />
 */
const ActionItemsCatchUpBanner = ({
  summary,
  onDismiss,
  onReviewAutomatable,
}) => {
  const newCount = Number(summary?.new_count) || 0;
  const automatableCount = Number(summary?.automatable_count) || 0;
  const openCount = Number(summary?.open_count) || 0;

  if (newCount <= 0) {
    return null;
  }

  const newLabel = `${newCount} new action item${newCount === 1 ? "" : "s"}`;
  const showOpenCount = openCount > newCount;

  return (
    <div className="action-items-catch-up-banner" role="status" aria-live="polite">
      <p className="action-items-catch-up-banner__text">
        <span className="action-items-catch-up-banner__segment">
          <strong>{newLabel}</strong>
          <span className="action-items-catch-up-banner__suffix">since your last visit</span>
        </span>
        {automatableCount > 0 ? (
          <span className="action-items-catch-up-banner__segment">
            <span className="action-items-catch-up-banner__sep" aria-hidden="true">
              ·
            </span>
            <button
              type="button"
              className="action-items-catch-up-banner__link"
              onClick={onReviewAutomatable}
            >
              {automatableCount} AI Assist only
            </button>
          </span>
        ) : null}
        {showOpenCount ? (
          <span className="action-items-catch-up-banner__segment">
            <span className="action-items-catch-up-banner__sep" aria-hidden="true">
              ·
            </span>
            <span className="action-items-catch-up-banner__muted">
              {openCount} still open
            </span>
          </span>
        ) : null}
      </p>
      <button
        type="button"
        className="action-items-catch-up-banner__close"
        onClick={onDismiss}
        aria-label="Dismiss catch-up summary"
        title="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

export default ActionItemsCatchUpBanner;
